
import GroupTitle from 'vux/src/components/group-title/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import ChinaAddressData from 'vux/src/datas/china_address.json'
import XAddress from 'vux/src/components/x-address/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'


export default {
components: {
Group,
GroupTitle,
Cell,
XInput,
Selector,
PopupPicker,
XAddress,
Datetime,
XNumber,
XTextarea,
XSwitch
},
data() {
return {
addressData: ChinaAddressData,
addressValue: ['广东省', '深圳市', '南山区'],
value1: '张三',
value2: '工艺技术',
value3: '',
value7: '',
value8: '',
value4: '',
time1: '2017-06-01',
value5: ['A'],
value6: [],
list: [
['A', 'B', 'C']
],
numberValue: 0
}
},
mounted() {
let _this = this;
this.$vux.confirm.show({
title: 'Vux is Cool',
content: 'Do you agree?',

onCancel() {
console.log('取消');

},
onConfirm() {
console.log('确定');
_this.test();
}
})
},
methods: {
test() {
this.tool.httpGet(
'/invite/activiteBanks', res => {
})
}

}

}




// WEBPACK FOOTER //
// ./src/components/HelloWorld.vue